export default "__VITE_ASSET__BCOPwDdC__"